import { IsString, IsNumber, IsEnum, IsOptional, IsNotEmpty, IsUUID } from "class-validator";
import { AttachmentsStatus } from "../../interface/attachments/attachments-response.interface";
import { CreateAttachmentsInterface, UpdateAttachmentsInterface } from "../../interface/attachments/modify-attachments.interface";

export class CreateAttachmentsDto implements CreateAttachmentsInterface {
  @IsString()
  @IsNotEmpty()
  bucket_name!: string;

  @IsString()
  @IsNotEmpty()
  storage_path!: string;

  @IsString()
  @IsNotEmpty()
  public_url!: string;

  @IsString()
  @IsNotEmpty()
  file_type!: string;

  @IsNumber()
  file_size!: number;

  @IsString()
  @IsNotEmpty()
  file_name!: string;

  @IsEnum(AttachmentsStatus)
  status!: AttachmentsStatus;
}

export class UpdateAttachmentsDto implements UpdateAttachmentsInterface {
  @IsUUID()
  @IsNotEmpty()
  id!: string;

  @IsOptional()
  @IsString()
  bucket_name?: string;

  @IsOptional()
  @IsString()
  storage_path?: string;

  @IsOptional()
  @IsString()
  public_url?: string;

  @IsOptional()
  @IsString()
  file_type?: string;

  @IsOptional()
  @IsNumber()
  file_size?: number;

  @IsOptional()
  @IsString()
  file_name?: string;

  @IsOptional()
  @IsEnum(AttachmentsStatus)
  status?: AttachmentsStatus;
}